import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import CheckboxWithText from '../../../GenericFormActions/SubComponents/CheckboxWithText/CheckboxWithText';
import {isValidObject} from '../../../../../Assets/functions/functions';

const AlertContentHeader = ({icon, title, text, checkboxObj}) => {
  const hasCheckbox = isValidObject(checkboxObj);

  return (
    <div className='alert-content-header'>
      {icon && <Image className='alert-icon' src={icon} />}
      <div className='alert-content-checkbox'>
        <div className='alert-content'>
          {title && <span className='alert-title'>{title}</span>}
          {text && <span className='alert-text'>{text}</span>}
        </div>
        {hasCheckbox && <CheckboxWithText {...checkboxObj} />}
      </div>
    </div>
  );
};
export default AlertContentHeader;
